module.exports = __webpack_public_path__ + "static/media/error2.78cc1098.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error2.svg
// module id = 156
// module chunks = 0